import {
    UPDATE_PROFILE_SUCCESS,
    UPDATE_PROFILE_ERROR
    } from "../../actionTypes/authActionTypes";
    
    const reducer = (state = {}, action) => {
      switch (action.type) {
        case UPDATE_PROFILE_SUCCESS:
          return {
            ...state,
            updateProfileData: action.payload,
          };
        case UPDATE_PROFILE_ERROR:
          return {
            ...state,
            updateProfileError: action.payload,
          };
        default:
          return state;
      }
    };
    
    export default reducer;
    